<script lang="ts">
  import { onMount } from "svelte";
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";

  const progress = tweened(0, {
    duration: 3500,
    easing: cubicOut,
  });

  onMount(() => {
    progress.set(0.99);
  });
</script>

<div class="fixed left-0 right-0 top-0 z-[100] h-[2px]">
  <div class="h-full bg-theme-green" style={`width: ${$progress * 100}%`}></div>
</div>
